import { useEffect } from "react";

import { useLocation, useNavigate } from "utils/routing";

// Legacy route shim: keep for backward compatibility and redirect to /section.
export default function Layout() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const redirectedPath = location.pathname.replace(/^\/course(\/|$)/, "/section$1");
    navigate(`${redirectedPath}${location.search}${location.hash}`);
  }, [location.hash, location.pathname, location.search, navigate]);

  return null;
}
